import { useConsoleRole } from '../../session/SessionContext';
import { sx } from '../../ui/designStyles';
import { AboutThis } from '../../ui/AboutThis';
import { tierLabel } from '../residents/common';
import { usePerf } from './ctx';
import { NotConnected, ReadOnlyLine, SectionHead, V9_PANE, V9_SECTION } from './v9parts';

/** The lines this tab draws (exported for the Spanish check). */
export const ADMIT = {
  lead: 'No referral feed connected yet',
  sub: 'Each referral will show clinical fit, payer, bed and the federal PASRR screen, so you can answer in one look. Nothing is shown until this building’s referral feed is connected to Aithora.',
  rank: 'Your buildings, slowest to answer first',
  waiting: 'Waiting for your answer',
  rankNone: 'Not connected yet. Time to answer is measured once each building’s referral feed is connected.',
  waitingNone: 'Not connected yet. Referrals show here as they arrive, with the time since each one came in.',
  about:
    'Referrals come from the hospital referral systems your discharge planners already use. Answering within an hour wins most referrals, because each one goes to several homes at once.',
} as const;

/**
 * Performance > Admissions (design ConsoleV9 isAdmitTab, L18975): referrals waiting for an
 * answer, the move-in checklist and the buildings ranking. No referral feed reaches Aithora
 * yet (Referral feed spec.md), so the tab keeps the design's sections and says so, with no
 * sample referral shown. Facility Admin, Super Admin and Support see it.
 */
export function AdmissionsTab() {
  const { role } = useConsoleRole();
  const { fa, canAct } = usePerf();
  const rank = role === 'SUPER_ADMIN';
  return (
    <div data-screen-label="Performance · Admissions" data-testid="perf-admissions" style={sx(V9_PANE)}>
      <div style={sx('display:flex;flex-direction:column;gap:3px;')}>
        <div style={sx('display:flex;align-items:baseline;gap:8px 12px;flex-wrap:wrap;')}>
          <span style={sx('font-size:18px;font-weight:700;line-height:1.4;')}>{ADMIT.lead}</span>
        </div>
        <div style={sx('font-size:16px;color:#54606C;line-height:1.4;max-width:96ch;text-wrap:pretty;')}>{ADMIT.sub}</div>
      </div>
      {rank && (
        <div data-screen-label="Admissions · Buildings" data-testid="adm-rank" style={sx(V9_SECTION)}>
          <SectionHead title={ADMIT.rank} />
          <NotConnected text={ADMIT.rankNone} />
        </div>
      )}
      <div data-screen-label="Admissions · Referrals" style={sx(V9_SECTION)}>
        <SectionHead title={ADMIT.waiting} />
        <NotConnected text={ADMIT.waitingNone} />
      </div>
      <AboutThis inline textStyle="font-size:14px;color:#54606C;line-height:1.4;">
        {ADMIT.about}
      </AboutThis>
      {!(fa && canAct) && <ReadOnlyLine text={'Read-only as ' + tierLabel(role)} />}
    </div>
  );
}
